<template>
  <div class="user-confirm-dailog dialog col-block">
    <div class="title-container col-block">
      <div class="title">{{ 'Success !'/* ___ */ }}</div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="description-container col-block">
      <div class="description">{{ 'We\'ve sent a verification code to your E-mail address.'/* ___ */ }}</div>
      <div class="description">{{ 'Please enter verification code to login.'/* ___ */ }}</div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <customForm
      :init="confirmData"
      :alerts="alerts"
      :forms="formOptions['field1']"
      @change="(result, validate, errors) => formOnChange('field1', result, validate, errors)"
    ></customForm>
    <div :style="{ height: '30px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ 'Cancel'/* ___ */ }}</span>
      </button>
      <div :style="{ width: '16px' }"></div>
      <button class="main-button circle-button" :class="{ loading: onSubmit }" :disabled="onError" @click="e => !onSubmit ? validateConfirmUser() : ''">
        <span>{{ 'Confirm'/* ___ */ }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { postConfirmUser } from '../../api'
import customForm from '../../components/tool/customForm'
import toastMethods from '../../mixins/toastMethods.vue'
import loginData from '../../mixins/loginData.vue'

export default {
  components: {
    customForm
  },
  mixins: [
    toastMethods,
    loginData
  ],
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      confirmData: {
        code: ''
      },
      alerts: {},
      result: {},
      validate: {},
      error: {},
      onSubmit: false
    }
  },
  computed: {
    onError () {
      return Object.values(this.alerts).filter(alert => alert && alert.type === 'error').length || Object.entries(this.error).some(([field, error]) => error.items.filter(item => this.formOptions[field].map(form => form.value).includes(item.field)).length)
    },
    // static
    formOptions () {
      return {
        field1: [
          {
            title: 'Verification'/* ___ */,
            value: 'code',
            type: 'input',
            placeholder: () => '6 digits code'/* ___ */,
            validate: 'required'
          }
        ]
      }
    }
  },
  methods: {
    formOnChange (field, result, validate, errors) {
      this.$set(this.error, field, errors)
      this.$set(this.validate, field, validate)
      this.result = {
        ...this.result,
        ...result
      }
    },
    customValidate (cols, rcols = []) {
      // const isSubmit = !cols
      const validates = {
      }
      for (let col of cols || Object.keys(this.confirmData)) {
        let alert = (validates[col] || (() => {}))(this.result[col])
        this.alerts = {
          ...this.alerts,
          [col]: alert || null
        }
      }
      this.alerts = {
        ...this.alerts,
        ...rcols.reduce((s, c) => ({ ...s, [c]: null }), {})
      }
      return !Object.values(this.alerts).filter(x => x).length
    },
    async validateConfirmUser () {
      let result = {}
      this.onSubmit = true
      for (let kv of Object.entries(this.validate)) {
        result[kv[0]] = await kv[1].validate()
      }
      result['custom'] = this.customValidate()
      if (!Object.values(result).includes(false)) {
        await this.confirmUser()
      }
      this.onSubmit = false
    },
    async confirmUser () {
      try {
        let data = {
          ...this.result,
          email: this.param.data.email
        }
        let response = await postConfirmUser(data)
        this.setUserData(response)
        this.addToast('success', response.data.result.message)
        this.$router.push(this.$route.query.redirect ? { path: this.$route.query.redirect } : { name: 'caseList' })
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.result.message)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/userConfirm.vue